// extracted by mini-css-extract-plugin
export default {"Container":"_Container--Qk5jC","Collapsed":"_Collapsed--tuHPn"};